// LLM_ContextPreviewPane.jsx

import React from "react";
import { Box, Typography, Button } from "@mui/material";

const ContextPreviewPane = ({
  questionType,
  previewedContext,
  promptTemplates,
  getPreviewContent,
  alerts,
  selectedSet,
  setSelectedSet,
  systemPrompt,
  questionTypePrompts,
  investorProfile,
  contextSelections,
  buildPrompt,
  setAutoPrompt, // ✅ USE THE NEW PROP NAME
}) => {

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
      <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 'bold' }}>
        {previewedContext 
          ? previewedContext.replace("TEMPLATE::", "") 
          : (["Specific Portfolio Alert", "Specific Favorites Alert", "Specific Opportunity Alert", "Specific stock - My Portfolio", "My_Portfolio_Items"].includes(questionType)
            ? questionType 
            : "No selection")
        }
      </Typography>

      {previewedContext ? (
        <Box
          sx={{
            width: '100%',
            overflow: 'auto',
            maxHeight: '60vh',
            border: '1px solid #ccc',
            borderRadius: '4px',
            padding: '8px',
            fontSize: '0.8rem',
            fontFamily: 'monospace',
            backgroundColor: '#fafafa',
          }}
        >
          <pre style={{ margin: 0, whiteSpace: 'pre-wrap' }}>
            {previewedContext.startsWith("TEMPLATE::")
              ? (promptTemplates[previewedContext.replace("TEMPLATE::", "")] || "[No preview]")
              : getPreviewContent(previewedContext)
            }
          </pre>
        </Box>
      ) : (
        ["Specific Portfolio Alert", "Specific Favorites Alert", "Specific Opportunity Alert", "Specific stock - My Portfolio", "My_Portfolio_Items"].includes(questionType) && alerts.length > 0 ? (
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            {alerts.map((item) => {
              const id = item.ID ?? item.id;
              const isSelected = selectedSet.has(id);

              return (
                <Button
                  key={id}
                  variant={isSelected ? "contained" : "outlined"}
                  onClick={() => {
                    const newSet = new Set(selectedSet);
                    newSet.has(id) ? newSet.delete(id) : newSet.add(id);
                    setSelectedSet(newSet);

                    const contexts = Array.from(newSet).map(selId => {
                      const a = alerts.find(x => x.ID === selId || x.id === selId);
                      if (!a) return "--- CONTEXT --- Company: N/A ---";
                      return `--- ITEM CONTEXT ---\nCompany: ${a.Company || a.company || "N/A"}\nTicker: ${a.Ticker || a.ticker || "N/A"}\nType: ${a.alert_type || "N/A"}\n--- END ---`;
                    }).join("\n\n");

                    const assembled = `${systemPrompt}
${questionTypePrompts[questionType] || ""}
${investorProfile}
${buildPrompt(contextSelections)}
${contexts}`;

                    setAutoPrompt(assembled); // ✅ FIXED
                  }}
                  sx={{
                    justifyContent: 'flex-start',
                    textTransform: 'none',
                    flexDirection: 'column',
                    alignItems: 'flex-start',
                    whiteSpace: 'normal',
                  }}
                >
                  <Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>
                    {`${item.Company || item.company || item.ticker || "N/A"}${item.Ticker ? ` | ${item.Ticker}` : ""}${item.alert_type ? ` | ${item.alert_type}` : ""}`}
                  </Typography>
                </Button>
              );
            })}
          </Box>
        ) : (
          <Typography variant="body2" color="text.secondary">
            No preview selected.
          </Typography>
        )
      )}
    </Box>
  );
};

export default ContextPreviewPane;
